import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Index as AccessDenied } from '../SubPages/AccessDenied/AccessDenied';
import { Index as LoginFailed } from '../SubPages/LoginFailed/LoginFailed';
import { Index as RegistrationError } from '../SubPages/RegistrationError/RegistrationError';

function Index() {
  return (
    <Routes>
      <Route path="AccessDenied" element={<AccessDenied />} />
      <Route path="LoginFailed" element={<LoginFailed />} />
      <Route path="RegistrationError" element={<RegistrationError />} />
    </Routes>
  );
}

export { Index };
